module.exports = __webpack_public_path__ + "static/grafika2@2x-c087177697ead80fa55dd5cffd65b069.png";